import React,{useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Tooltip } from '@mui/material';

import "./FormDialog.css"
import close from '../../assets/icons/close.svg'

export default function SharePopup({ open, handleClose, title, data }) {

    const [copyState, setCopyState] = useState(false);

    const copyJiraId = (text) => {
        navigator.clipboard.writeText(text);
        setCopyState(true);
    }

    return (
        <React.Fragment>
            <Dialog
                className='share-dialog'
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle className="alert-dialog-title">
                    {title}
                    <Tooltip title='Close' arrow placement='bottom' >
                    <img
                        tabIndex={0}
                        src={close}
                        onClick={handleClose}
                        onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault(); // Prevent default behavior (e.g., scrolling)
                                handleClose(); // Call the handleClose function
                            }
                        }}
                        alt='/'
                        draggable={false}
                        style={{ cursor: "pointer" }} // Add cursor style to indicate interactivity
                    />
                    </Tooltip>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <a href={data} target="_blank" rel="noopener noreferrer" className='link'>
                            {data}
                        </a>
                        <button onClick={() => copyJiraId(data)} className='copybtn' disabled={copyState}>{copyState ? "Copied" : "Copy"}</button>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}